import { NotificationViewDto } from "functions/api/notifications/getUserNotifications";
import { Dispatch, SetStateAction } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import { NotificationListItem } from "./NotificationListItem";

export interface NotificationsListProps {
  notificationsList: NotificationViewDto[];
  setNotificationsList: Dispatch<SetStateAction<NotificationViewDto[]>>;
  showNotifications: boolean;
  setShowNotifications: Dispatch<SetStateAction<boolean>>;
}

/**
 * Render a list of notification items.
 *
 * @param props - Destructured parameter object
 * @param props.notificationsList - Array of notifications to render
 * @param props.setNotificationsList - Callback to update the notifications list
 * @param props.setShowNotifications - Callback to show/hide the notifications panel
 */
export const NotificationsList = ({
  notificationsList,
  setNotificationsList,
  setShowNotifications,
}: NotificationsListProps): React.ReactElement => {
  return (
    <div className="position-relative">
      <ListGroup>
        {notificationsList.map((n) => (
          <NotificationListItem
            key={n.notificationId}
            notification={n}
            setNotificationsList={setNotificationsList}
            setShowNotifications={setShowNotifications}
          />
        ))}
      </ListGroup>
    </div>
  );
};

NotificationsList.displayName = "NotificationsList";
